import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { SopoConfirmData, SopoConfirmSettings } from '../../interfaces/confirm';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';
import { IonicModule } from "@ionic/angular";
import { CommonModule } from '@angular/common';
import { PredictedColor } from '@soposopo/sopo-models';

export interface SopoDisableSideBettingSettings extends SopoConfirmSettings {
    data: SopoDisableSideBettingData;
}

export interface SopoDisableSideBettingData extends SopoConfirmData {
    color: PredictedColor;
    amount: number;
    currency: string;
    canPredict: boolean;
}

@Component({
    selector: 'app-sopo-disable-side-betting',
    templateUrl: './sopo-disable-side-betting.component.html',
    styleUrls: ['./sopo-disable-side-betting.component.scss'],
    standalone: false
})
export class SopoDisableSideBettingComponent implements OnInit, OnDestroy {
    dismissAfterTimeout: NodeJS.Timeout;
    header: string = '';
    body: string = '';
    amount: number | null = null;
    currency: string | null = null;
    color: PredictedColor | null = null;
    dismissAfter: number = 0;
    okText: string = 'DISABLE NOTIFICATIONS';
    cancelText: string = 'CLOSE';
    canPredict: boolean = false;
    sCss: string[] = [];

    notificationsDisabled: boolean = false;

    constructor(
    @Inject(SOPO_DIALOG_DATA) data: SopoDisableSideBettingData,
        private renderer: Renderer2,
        private sopoDialogRef: SopoDialogRef,
    ) {
        if (data.header) this.header = data.header;
        if (data.body) this.body = data.body;
        if (data.amount) this.amount = data.amount;
        if (data.currency) this.currency = data.currency;
        if (data.color) this.color = data.color;
        if (data.dismissAfter) this.dismissAfter = data.dismissAfter;
        if (data.okText) this.okText = data.okText;
        if (data.cancelText) this.cancelText = data.cancelText; 
        if (data.canPredict) this.canPredict = data.canPredict;
        if (data.sCss) this.sCss = data.sCss;
    }

    ngOnInit() {
        if (this.dismissAfter && this.dismissAfter > 0) {
            this.dismissAfterTimeout = setTimeout(() => {
                this.close();
            }, this.dismissAfter);
        }
        this.notificationsDisabled = localStorage.getItem('dontShowAgain_sideBetting') === 'true';
        if (this.notificationsDisabled) {
            this.okText = 'ENABLE NOTIFICATIONS';
        }
    }

        ngAfterViewInit(): void {
        this.getContainerCss();
    }

    getContainerCss() {
        const container = document.getElementsByClassName('now-opening')[0];
        if (this.sCss && this.sCss.length !== 0) {
            for (let className of this.sCss) {
                this.renderer.addClass(container, className);
            };
        }
        this.renderer.removeClass(container, 'now-opening');
    }

    toggleNotifications() {
        this.notificationsDisabled = !this.notificationsDisabled;
        if (this.notificationsDisabled) {
            localStorage.setItem('dontShowAgain_sideBetting', 'true');
            this.okText = 'ENABLE NOTIFICATIONS';
        } else {
            localStorage.setItem('dontShowAgain_sideBetting', 'false');
            this.okText = 'DISABLE NOTIFICATIONS';
        }
    }

    predict() {
        this.sopoDialogRef.close(true);
    }

    close() {
        this.sopoDialogRef.close(false);
    }

    ngOnDestroy(): void {
        if (this.dismissAfterTimeout) clearTimeout(this.dismissAfterTimeout);
    }
}
